export const allowedTypes = ['user', 'admin', 'bat', 'batadmin'];
export const allowedAllTypes = ['user', 'admin', 'bat', 'batadmin', 'suspect', 'anonymous'];